import { Component, inject, Input, OnInit } from '@angular/core';
import {
  ControlContainer,
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
} from '@angular/forms';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';

@Component({
  selector: 'app-search-bar',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './search-bar.component.html',
  styleUrl: './search-bar.component.scss',
  viewProviders: [
    {
      provide: ControlContainer,
      useFactory: () => inject(ControlContainer, { skipSelf: true }),
    },
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: SearchBarComponent,
    },
  ],
})
export class SearchBarComponent implements ControlValueAccessor, OnInit {
  @Input() placeholder: string = '';
  @Input() debounce: number | null = null;

  private valueSubject = new Subject<string>();

  ngOnInit(): void {
    this.valueSubject
      .pipe(debounceTime(this.debounce || 0), distinctUntilChanged())
      .subscribe((value: string) => {
        this.onChange(value);
      });
  }

  public handleChange(event: Event): void {
    if (this.disabled) return;
    const value = (event.target as HTMLInputElement).value;

    this.value = value;
    if (this.debounce !== null) {
      this.valueSubject.next(value);
    } else {
      this.onChange(value);
    }
    this.markAsTouched();
  }

  value: string = '';
  touched = false;
  disabled = false;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onChange = (_: string) => {};
  onTouched = () => {};

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  writeValue(value: string): void {
    this.value = value;
  }

  private markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }
}
